export interface DirectAd {
  Advertiser: string
  'Campaign Name': string
  'Creative Name': string
  Image: string
  Headline: string
  Brand: string
  'Click URL': string
  'Open In Default Browser'?: boolean
}

export const useRandomDirectAd = async (): Promise<DirectAd | undefined> => {
  const { data } = await useFetch<DirectAd[] | undefined>('/api/direct-ads', {
    retry: 0,
  })
  if (!data.value || !Array.isArray(data.value)) return undefined

  const randomIndex = Math.floor(Math.random() * data.value.length)

  return data.value[randomIndex]
}
